"use client";
import React from "react";
import classes from "./ImageContentCard.module.scss";
import { formatDistanceToNow } from "date-fns";
import { useRouter } from "next/navigation";
import Image from "next/image";

type News = {
  id: number;
  title: string;
  description: string;
  readTime: string;
  imageUrl: any;
  footerStartTitle?: string;
  footerEndTitle?: string;
  createdAt?: any;
  postExcerpt: string;
  categoryName: string;
  slug: any;
};

type LatestNewsCardProps = {
  news: News;
};

const ImageContentCard = ({ news }: LatestNewsCardProps) => {
  const router = useRouter();
  const readMoreClick = (slug: any) => {
    router.push(`/article/${slug}`);
  };
  return (
    <div
      className={classes["card-container"]}
      onClick={() => readMoreClick(news.slug)}
    >
      <div className={classes["card-content"]}>
        <div className={classes["image"]}>
          <Image
            src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/${news.imageUrl}`}
            alt="Trending News Image"
            width={1200}
            height={800}
          />
        </div>

        <span className={classes.readTime}>
          {formatDistanceToNow(new Date(news.createdAt)) + " ago"}
        </span>
        <h3 className={classes.title}>{news.title}</h3>
        <p className={classes.description}>{news.postExcerpt}</p>
        <div className={classes.footer}>
          <span className={classes.footerStartTitle}>{news.categoryName}</span>
        </div>
      </div>
    </div>
  );
};

export default ImageContentCard;
